/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { requestGetResourceSchedules } from "services/settings/scheduleAdmin/aboutScheduleAdmin";

const useRegisterScheduleData = ({
    loadingRequest, filters
}) => {
    //#region States
    const [schedules, setSchedules] = useState([]);
    const [nonBusinessDays, setNonBusinessDays] = useState([]);
    const [triggerRequest, setTriggerRequest] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (filters.areCompleted()) 
            fillData();
    }, [filters.value]);
    useEffect(() => {
        if (!triggerRequest) return;
        fillData();
        setTriggerRequest(false);
    }, [triggerRequest]);
    //#endregion
    //#region Functions
    function clearData() {
        setNonBusinessDays([]);
        setSchedules([]);
    }
    const fillData = async () => {
        loadingRequest.show();
        const data = await requestGetResourceSchedules(filters.value);
        loadingRequest.hide();
        setSchedules(data.schedules);
        setNonBusinessDays(data.nonBusinessDays);
    }
    //#endregion
    return {
        schedules,
        nonBusinessDays,
        setTriggerRequest,
        fill: fillData, 
        clear: clearData
    };
}

export default useRegisterScheduleData;